import React, { useEffect, useState, useRef } from 'react';
import { Card, CardBody, CardFooter, Col, Input, Row, Spinner, CardHeader } from 'reactstrap';
import { RiMessage2Fill } from 'react-icons/ri';
import { AiOutlineSend } from 'react-icons/ai';
import { FaChevronDown } from "react-icons/fa";
import moment from 'moment-timezone';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import CustomToast from '../utils/CustomToast';
import { CgPushDown } from "react-icons/cg";

const ChatWidgetV2 = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [newMessage, setNewMessage] = useState(false);

    const cookies = useCookies(['currentUser', 'userDetails', 'isLoggedIn', 'userRole', 'judge_id', 'awardStatus', 'token', 'award_id', 'section', 'token']);
    const currentUser = cookies[0].currentUser;
    const award_id = cookies[0].award_id;
    const token = cookies[0].token;

    const [comments, setComments] = useState([]);
    const [newComment, setNewComment] = useState('');
    const [formStatus, setFormStatus] = useState('standby');

    const [reloadCount, setReloadCount] = useState(0);

    const [commentsLength, setCommentsLength] = useState(0);
    const [showNewMessageButton, setShowNewMessageButton] = useState(false);

    const userToken = {
        user_id: currentUser,
        token: token
    }

    const getChat = () => axios.get(process.env.REACT_APP_API_ENDPOINT + 'award/' + award_id + '/entrant/' + currentUser + '/chat', {
        params: {
            ...userToken,
            open_toggle: isOpen,
        },
    });

    const postChat = (data) => axios.post(process.env.REACT_APP_API_ENDPOINT + 'chat', data, {
        params: {
            ...userToken,
            award_id: award_id,
        },
    });

    const fetchChat = () => {
        getChat()
            .then(response => {
                const { data, seen_status } = response.data;
                if (data) {
                    setComments(data);
                    setNewMessage(seen_status !== 'Viewed' && seen_status !== 'Empty message');
                    toggleNewMessage(data.length, data[data.length - 1]);
                } else {
                    CustomToast.defaultWarning();
                }
            })
            .catch(() => {
                CustomToast.defaultError();
            });
    };

    const handleChangeComment = async (e) => {
        const { value } = e.target;

        setNewComment(value);
    };

    const formatTimestamp = (timestamp) => {
        moment.tz.setDefault('Europe/Dublin');
        const now = moment();
        let format = 'MMM DD, YYYY h:mm a';

        if (now.format('YYYY') === moment(timestamp).format('YYYY'))
            format = 'MMM DD h:mm a';

        return moment(timestamp).format(format);
    };

    const handleKeyDown = async (e) => {
        if (e.keyCode === 13 && !e.shiftKey) {
            e.preventDefault()
            await handleSendMessage(e);
        } else if (e.keyCode == 27) {
            setIsOpen(false);
        }
    }

    const handleSendMessage = async (e) => {
        e.preventDefault();
        if (!newComment || newComment.trim() === '') {
            return;
        }
        setFormStatus('loading');
        setNewComment('');

        const data = {
            'message': newComment,
            'type': 'User',
        }

        postChat(data).then(response => {
            const status = response.data.status;
            if (status === 'Success') {
                setFormStatus('standby');
                setReloadCount(count => count + 1);
                fetchChat();
            } else {
                CustomToast.defaultWarning();
                setFormStatus(false);
            }
        }).catch(() => {
            CustomToast.defaultError();
            setFormStatus(false);
        });
    };

    const toggleChat = async () => {
        const isChatOpen = isOpen;
        setIsOpen(prev => !prev);
        if (!isChatOpen) {
        }
    }

    useEffect(() => {
        if (currentUser && currentUser != "") {
            if (isOpen) {
                fetchChat();
            }

            const interval = setInterval(fetchChat, 60000);

            return () => clearInterval(interval);
        }
    }, [currentUser, isOpen]);

    const toggleNewMessage = (length, role) => {
        setCommentsLength(prevLength => {
            if (isOpen) {
                if (length !== prevLength && prevLength !== 0 && role && role.user && role.user.role && role.user.role == "Admin") {
                    const isButtom = scrollableDivRef.current.scrollHeight > 400 && scrollableDivRef.current.scrollTop + scrollableDivRef.current.clientHeight <= 350;
                    if (isButtom) {
                        setShowNewMessageButton(true);
                    }
                }
            }
            return length;
        });
    }

    const scrollableDivRef = useRef(null);

    const handleNewMessageClick = () => {
        if (scrollableDivRef.current) {
            scrollableDivRef.current.scrollTo({
                top: scrollableDivRef.current.scrollHeight,
                behavior: 'smooth',
            });
        }
        setShowNewMessageButton(false);
    };

    useEffect(() => {
        if (scrollableDivRef.current) {
            scrollableDivRef.current.scrollTo({
                top: scrollableDivRef.current.scrollHeight,
                behavior: 'smooth',
            });
        }
    }, [isOpen])

    useEffect(() => {
        const div = scrollableDivRef.current;

        const handleScroll = () => {
            if (!div) return;

            const distanceFromBottom = scrollableDivRef.current.scrollTop + scrollableDivRef.current.clientHeight;

            if (distanceFromBottom >= 350) {
                setShowNewMessageButton(false);
            }
        };

        if (div) {
            div.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (div) {
                div.removeEventListener('scroll', handleScroll);
            }
        };

    }, [scrollableDivRef]);

    return (
        <>
            <div className={`entrant-chat-widget-container ${isOpen ? 'chat-container-show' : ''}`}>
                <Card className="h-100 entrant-chat-widget-container-card">
                    <CardHeader>
                        <h3 className="header-text mb-0" style={{ color: "#1ec2f3" }}>CHAT WITH US</h3>
                    </CardHeader>
                    <Card style={{ border: 'none' }}>
                        <div className='chat-container comment-auto-scroll p-4' ref={scrollableDivRef}>
                            {[...comments].reverse().map(({ message, created_at, user, image_url }, index) => (
                                <div className='entry-comment-container' key={index}>
                                    <>
                                        <Card className='comment-body' style={{ border: 'none' }}>
                                            <CardBody className='px-1'>
                                                {user.role != 'Admin' ?
                                                    <Row className='align-items-end'>
                                                        <Col lg='1' className='mb-0 px-0'>
                                                        </Col>
                                                        <Col lg='11' className='mb-0 px-0'>
                                                            <Card className='comment-send'>
                                                                <CardBody className='px-3 py-2'>
                                                                    <p className='comment-data mb-0'>{message}</p>
                                                                </CardBody>
                                                                {Number(currentUser) == Number(user.id) ?
                                                                    <p className='comment-send-name'>You <span>{formatTimestamp(created_at)}</span></p>
                                                                    :
                                                                    <p className='comment-send-name'>{user.first_name} {user.last_name} <span>{formatTimestamp(created_at)}</span></p>
                                                                }
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                    :
                                                    <Row className='align-items-end'>
                                                        <Col lg='11' className='mb-0 px-0'>
                                                            <Card className='comment-receive'>
                                                                <CardBody className='px-3 py-2'>
                                                                    <p className='comment-data mb-0'>{message}</p>
                                                                </CardBody>
                                                                <p className='comment-receive-name'>Admin <span>{formatTimestamp(created_at)}</span></p>
                                                            </Card>
                                                        </Col>
                                                        <Col lg='1' className='mb-0 px-0'>
                                                            {/*<img src={PlaceholderIcon} className='user-icon-image' />*/}
                                                        </Col>
                                                    </Row>
                                                }
                                            </CardBody>
                                        </Card>
                                    </>
                                </div>
                            ))}
                        </div>
                    </Card>
                    <CardFooter>
                        {showNewMessageButton ?
                            <button className="send-comment-button mr-1 new-message-button" onClick={handleNewMessageClick}>New Message <CgPushDown /></button>
                            : null}
                        <Row className='align-items-center'>
                            <Col lg='10' className='mb-0'>
                                <Input
                                    type='textarea'
                                    rows='1'
                                    placeholder='Message'
                                    className='comment-area'
                                    onChange={handleChangeComment}
                                    onKeyDown={handleKeyDown}
                                    value={newComment}
                                    maxlength={255}
                                    disabled={formStatus === 'loading'}
                                // onFocus={viewMessage}
                                />
                            </Col>
                            <Col lg='2' className='pl-0 mb-0'>
                                {formStatus === 'loading' ?
                                    <button
                                        className='send-comment-button mr-1'
                                    >
                                        <Spinner
                                            color='info'
                                            size='sm' />
                                    </button>
                                    :
                                    <button
                                        className='send-comment-button mr-1'
                                        onClick={handleSendMessage}
                                    >
                                        <AiOutlineSend />
                                    </button>
                                }
                            </Col>
                        </Row>
                    </CardFooter>
                </Card>
            </div>
            <div className='entrant-chat-widget cursor-pointer' onClick={toggleChat}>
                <span className={`position-relative badge badge-danger chat-widget-notif ${newMessage ? 'new-message' : ''}`}>
                    <small>&nbsp;</small>
                </span>
                {isOpen ?
                    <FaChevronDown className={`entrant-chat-widget-icon ${newMessage ? 'new-message' : ''}`} />
                    :
                    <RiMessage2Fill className={`entrant-chat-widget-icon ${newMessage ? 'new-message' : ''}`} />
                }
            </div>
        </>
    );
};

export default ChatWidgetV2;